import React from 'react';
import data from '../data/Experience.json';
const Experience = () => {
  return (
    <>
      <h2 className='mb-8'>Where I’ve Worked</h2>
      {
        data.map((item) => {
          return (
            <div key={item.id} className='mb-8'>
              <a href={item.website} target='_blank' rel="noreferrer">
                <div className='wrapper experience flex flex-column gap-2'>
                  <div className='w-1/5 duration uppercase text-sm pt-2'>{item.time}</div>
                  <div className='w-4/5'>
                    <div className='name flex items-center'>
                      {item.company}
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px" aria-hidden="true"><path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd"></path></svg>
                    </div>
                    <div className='designation'>{item.designation}</div>
                    <div className='description' >{item.description}</div>
                    {/* <div className='description'>{item.description}</div> */}
                    <div className='tech'>
                      {
                        item.technology.map((tech, index) => { return (<div className="tag" key={index}>{tech}</div>) })
                      }
                    </div>
                  </div>
                </div>
              </a>
            </div>
          )
        }
        )}
      <div>
      </div>
    </>
  );
};

export default Experience;